import { message, Upload } from "antd";
import { UploadIcon } from "../../Icons/uploadIcon";
import "./style.scss";
import { usePostData } from "../../Network/usePostData";

const { Dragger } = Upload;

interface ExcelUploaderProps {
  onChange?: (binaryData: any) => void; // Callback to return the file binary data
}

export const ExcelUploader = ({ onChange }: ExcelUploaderProps) => {
  const handleUpload = async (file: File) => {
    try {
      onChange?.(file);
    } catch (error) {
      message.error(`${file.name} upload failed. Please try again.`);
    }
  };

  const props = {
    name: "file",
    multiple: false,
    accept: ".xls,.xlsx",
    beforeUpload: (file: File) => {
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        message.error("You can only upload Excel files (.xls, .xlsx)!");
        return Upload.LIST_IGNORE; // Prevent adding invalid files to the upload list
      }
      handleUpload(file);
      return false; // Prevent automatic upload
    },
  };

  return (
    <Dragger {...props}>
      <p className="ant-upload-drag-icon">
        <UploadIcon />
      </p>
      <p className="uploader-text-helper">
        Drop Excel file here or <a>Browse</a> files (.xls, .xlsx)
      </p>
    </Dragger>
  );
};
